






import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { OrderState } from '../../entities/OrderState';
import { localize } from '../../filters/localize';

@Component
export default class OrderStateToolTip extends Mixins(BaseMixin) {
    @Prop({ required: true })
    private orderState!: OrderState;

    private toolTipMessage(): string {
        let returnValue = `<div class="delivery-time-tooltip__tooltip-innertext">
            <span>${localize(
                this.l10n.ORDER_ITEM_STATE_TOOLTIP.HEADER_TEXT
            )}</span></div>`;
        returnValue += `<div class="delivery-time-tooltip__tooltip-innertext">
            <span>${localize(this.l10n.ORDER_ITEM_STATE_TOOLTIP.READY_FOR_PICKING_TEXT)} </span>
            <span>${this.orderState.readyForPicking}</span>
        </div>`;
        returnValue += `<div class="delivery-time-tooltip__tooltip-innertext">
            <span>${localize(this.l10n.ORDER_ITEM_STATE_TOOLTIP.READY_FOR_SHIPMENT_TEXT)} </span>
            <span>${this.orderState.readyForShipment}</span>
        </div>`;
        returnValue += `<div class="delivery-time-tooltip__tooltip-innertext">
            <span>${localize(this.l10n.ORDER_ITEM_STATE_TOOLTIP.QUANTITY_INVOICED_TEXT)} </span>
            <span>${this.orderState.quantityInvoiced}</span>
        </div>`;
        returnValue += `<div class="delivery-time-tooltip__tooltip-innertext">
            <span>${localize(this.l10n.ORDER_ITEM_STATE_TOOLTIP.IN_ORDER_TEXT)} </span>
            <span>${this.orderState.inOrder}</span>
        </div>`;
        return returnValue;
    }
}
